export const checkAccess = (pageName, action) => {
  const userRightsJson = sessionStorage.getItem("userRights");
  if (!userRightsJson) return false; // Early exit if no user rights data is available

  const userRights = JSON.parse(userRightsJson);

  // Check access by iterating through each menu item and its modules and pages
  for (let menuItem of userRights) {
    for (let module of menuItem.Modules) {
      for (let page of module.Page) {
        if (page.Route === pageName) {
          // console.log(page, "pagepagepagepage")
          return page[`Is_${action}`]; // Dynamically access the action property
        }
      }
    }
  }

  return false; // Return false if no matching page name is found
};

export const getPageDetails = (pageName) => {
  const userRightsJson = sessionStorage.getItem("userRights");
  if (!userRightsJson) return false; // Early exit if no user rights data is available

  const userRights = JSON.parse(userRightsJson);

  // Check access by iterating through each menu item and its modules and pages
  for (let menuItem of userRights) {
    for (let module of menuItem.Modules) {
      for (let page of module.Page) {
        if (page.Route === pageName) {
          return page; // Dynamically access the action property
        }
      }
    }
  }

  return {}; // Return false if no matching page name is found
};

export function transformPageIdArray() {
  let originalArray = [];
  // Map to transform Page_Name to the desired format
  const userRightsJson = sessionStorage.getItem("userRights");
  console.log(JSON.parse(userRightsJson), "userRightsJsonuserRightsJson");
  if (!userRightsJson) return false;
  const userRights = JSON.parse(userRightsJson);
  for (let i = 0; i < userRights.length; i++) {
    if (userRights[i].Menu_Name === "Transaction") {
      for (let j = 0; j < userRights[i].Modules?.length; j++) {
        if (userRights[i].Modules[j]?.Module_Name === "Shipment Management") {
          originalArray = userRights[i]?.Modules[j]?.Page;
        }
      }
    }
  }

  // console.log(originalArray, "originalArray");
  const pageNameMapping = {
    "Pickup Assignment (PRS Generation)": "Pickup_Memo",
    "Pickup Updation": "Pickup_Updation",
    "Warehouse Inward": "Inward_At_Warehouse",
    "Connection Planning (Memo)": "Connection_Memo",
    "Connection Status Update": "Connection_Memo_Update",
    "Destination Inward": "Connection_Memo_Receive",
    "Delivery Planning (DRS Generation)": "Delivery_Memo",
    "Delivery Confirmation (POD Upload)": "CN_Delivery",
  };

  return originalArray
    .filter((item) => pageNameMapping[item.Page_Name]) // Filter only the required pages
    .map((item) => ({
      pageId: item.Page_Id,
      Page_Name: pageNameMapping[item.Page_Name], // Use the mapped value
    }));
}
